import React, { useState, useEffect } from "react";
import "./video.css";

const Video = () => {
  const [iniciar, setIniciar] = useState(false);

  const entrarEmTelaCheia = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen().catch((err) => console.error(err));
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  const iniciarApresentacao = () => {
    entrarEmTelaCheia();
    setIniciar(true);
  };

  // Ativa a apresentação ao pressionar qualquer tecla
  useEffect(() => {
    const handleKeyPress = () => {
      if (!iniciar) {
        iniciarApresentacao();
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [iniciar]);

  if (!iniciar) {
    return (
      <div className="video-tela-inicial">
        <button onClick={iniciarApresentacao} className="video-botao-iniciar">
          Click ou Aperte qualquer tecla para iniciar - Apresentação TV
          Marmitaria Donna Rose
        </button>
      </div>
    );
  }

  return (
    <div className="video-container">
      <video
        src="https://tvdonnarose.com.br/videos/videodonnarose.mp4"
        autoPlay
        muted
        loop
        className="video-player"
      />
    </div>
  );
};

export default Video;
